import { ClientFilter } from 'src/@types/filters';
import { Role } from 'src/@types/roles';

export const ROLE = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Administrator',
  MANAGER: 'Manager',
  AGENT: 'Agent',
  AFFILIATE: 'Affiliate',
  PLAYER: 'Player',
} as const;

export const ACCESS_LEVELS = {
  [ROLE.SUPER_ADMIN]: '5',
  [ROLE.ADMIN]: '4',
  [ROLE.MANAGER]: '3',
  [ROLE.AGENT]: '2',
  [ROLE.AFFILIATE]: '2',
  [ROLE.PLAYER]: '1',
} as const;

export const ROLE_API_VALUES: Record<Role, string> = {
  [ROLE.SUPER_ADMIN]: 'super_admin',
  [ROLE.ADMIN]: 'admin',
  [ROLE.MANAGER]: 'manager',
  [ROLE.AGENT]: 'agent',
  [ROLE.AFFILIATE]: 'affiliate',
  [ROLE.PLAYER]: 'player',
};

export const DEFAULT_ROLE_OPTIONS: Partial<Record<Role, Role>> = {
  [ROLE.ADMIN]: ROLE.MANAGER,
  [ROLE.MANAGER]: ROLE.AGENT,
  [ROLE.AGENT]: ROLE.PLAYER,
  [ROLE.AFFILIATE]: ROLE.PLAYER,
} as const;

export const INITIAL_FILTERS: ClientFilter = {
  manager: [],
  agent: [],
  player: [],
};

export const ROLE_SELECTION_OPTIONS: Partial<Record<Role, { value: Role; label: string }[]>> = {
  [ROLE.SUPER_ADMIN]: [
    { value: ROLE.MANAGER, label: 'Manager' },
    { value: ROLE.AGENT, label: 'Agent' },
    { value: ROLE.PLAYER, label: 'Player' },
  ],
  [ROLE.ADMIN]: [
    { value: ROLE.MANAGER, label: 'Manager' },
    { value: ROLE.AGENT, label: 'Agent' },
    { value: ROLE.PLAYER, label: 'Player' },
  ],
  [ROLE.MANAGER]: [
    { value: ROLE.AGENT, label: 'Agent' },
    { value: ROLE.PLAYER, label: 'Player' },
  ],
  [ROLE.AGENT]: [{ value: ROLE.PLAYER, label: 'Player' }],
  [ROLE.AFFILIATE]: [{ value: ROLE.PLAYER, label: 'Player' }],
};
export const getAdditionalRoleOptions = (accessLevel: number) => {
  const FILTERABLE_ROLES_BY_ROLE: Partial<Record<Role, Role[]>> = {
    [ROLE.MANAGER]: [ROLE.MANAGER, ROLE.AGENT, ROLE.PLAYER],
    [ROLE.AGENT]: [ROLE.AGENT, ROLE.PLAYER],
    [ROLE.PLAYER]: [ROLE.PLAYER],
  };
  if (accessLevel < 4) {
    FILTERABLE_ROLES_BY_ROLE[ROLE.MANAGER] = [];
  }
  if (accessLevel < 3) {
    FILTERABLE_ROLES_BY_ROLE[ROLE.AGENT] = [];
  }
  return FILTERABLE_ROLES_BY_ROLE;
};
